import React from "react";
import { getCmsData } from "../../functions";

const Acknowledgement = () => {
  const cmsData = getCmsData("acknowledgementDataCMS");
  if (!cmsData) return null;

  const { acknowledgement } = cmsData;

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="statement col-lg-8 col-md-12">
          <p>
            {" "}
            <span
              dangerouslySetInnerHTML={{
                __html: acknowledgement.content
              }}
            ></span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Acknowledgement;
